<template>
    <div class="app">
        <!--面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>固件设备连接记录</el-breadcrumb-item>
            <el-breadcrumb-item>记录列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--卡片视图区域-->
        <el-card class="el-card">
            <vxe-toolbar>
                <template #buttons>
                    <vxe-button @click="exportCurrDataEvent4">导出当前页</vxe-button>
                    <vxe-button @click="exportSelectEvent">导出选中</vxe-button>
                    <vxe-button @click="exportAllDataEvent4">全量导出</vxe-button>
                </template>
            </vxe-toolbar>
            <!--历史列表区域-->
            <vxe-table
                    v-loading="tableLoading"
                    border
                    show-footer
                    highlight-hover-row
                    ref="xTable4"
                    align="center"
                    max-height="650"
                    :data="productList.records">
                <vxe-table-column type="checkbox" width="60"></vxe-table-column>
                <vxe-table-column field="userName" title="用户名"></vxe-table-column>
                <vxe-table-column field="deviceId" title="手机设备ID"></vxe-table-column>
                <vxe-table-column field="equipmentMac" title="设备Mac地址"></vxe-table-column>
                <vxe-table-column field="creationTime" title="创建时间" width="150"></vxe-table-column>
            </vxe-table>
            <!--分页区域-->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pageNum"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="tableData"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="productList.total">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>

    export default {
        name: "RecordList",
        data() {
            return {
                tableData: [
                ],
                queryInfo: {
                    pageNum: 1,
                    pageSize: 10,
                    userId: window.sessionStorage.getItem('userId')
                },
                productList: {
                    records: [],
                    total: 0
                },
                // 分类列表，用于选择父级菜单
                categoryForm: [],
                tableLoading:false
            }
        },
        created() {
            this.getProductList();
        },
        methods: {
            //导出全部数据
            async exportAllDataEvent4 () {
                this.tableLoading = true
                let {data: res} = await this.$http.post(`/device/selectAll`, {userId:window.sessionStorage.getItem('userId')});
                this.tableLoading = false
                setTimeout(() => {
                    this.$refs.xTable4.exportData({
                        filename: '自定义文件名',
                        type: 'csv',
                        isHeader: true,
                        isFooter: true,
                        data: res.data
                    })
                }, 100)
            },
            //导出选中
            exportSelectEvent () {
                this.$refs.xTable4.exportData({
                    data: this.$refs.xTable4.getCheckboxRecords()
                })
            },
            //导出当前表格数据
            exportCurrDataEvent4 () {
                this.$refs.xTable4.exportData({
                    filename: '自定义文件名',
                    type: 'csv',
                    isHeader: true,
                    isFooter: true
                })
            },
            //获取历史数据列表
            async getProductList() {
                this.tableLoading = true
                let {data: res} = await this.$http.post(`/device/selectPage`, this.queryInfo);
                this.tableLoading = false
                // if (res.code !== 1) return this.$message.error("获取历史数据！");
                this.productList.total = res.data.total;
                this.productList.records = res.data.records;
            },
            // 监听pageSize改变的事件
            handleSizeChange(newSize) {
                this.queryInfo.pageSize = newSize;
                this.getProductList()
            },
            // 监听pageNum改变的事件
            handleCurrentChange(newPage) {
                this.queryInfo.pageNum = newPage;
                this.getProductList()
            },
            // 导出数据
            excel() {

            }
        }
    }
</script>

<style lang="less" scoped>
    .el-table {
        margin-top: 15px;
        font-size: 12px;
    }

    .el-pagination {
        margin-top: 15px;
    }
    .app .el-card {
        width: 99%;
    }
</style>
